module.exports = __webpack_public_path__ + "img/xtjs.7e2eda96.png";